import { SubscriberLookupResolveService } from './shared/services/subscriber-lookup-resolve.service';
import { SubscriberService } from './shared/services/subscriber.service';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscribersRoutingModule } from './subscribers-routing.module';
import { SubscriberShellComponent } from './subscriber-shell/subscriber-shell.component';
import { SubscriberListComponent } from './subscriber-list/subscriber-list.component';

@NgModule({
  imports: [CommonModule, SharedModule, SubscribersRoutingModule],
  providers: [SubscriberService, SubscriberLookupResolveService],
  declarations: [SubscriberShellComponent, SubscriberListComponent],
})
export class SubscribersModule {}
